import { FormListFieldData } from 'antd'

import { InsuredAmount } from './InsuredAmount'
import { ItemBasicFields } from './ItemBasicFields'
import { ItemLocationFields } from './ItemLocationFields'
import { PropertyCategoriesFields } from './PropertyCategoriesFields'

type Props = { field: FormListFieldData }

export const ItemField = ({ field }: Props) => {
  return (
    <>
      <ItemBasicFields fieldKey={field.name} />
      <InsuredAmount fieldKey={field.name} />
      <ItemLocationFields fieldKey={field.name} />
      <PropertyCategoriesFields fieldKey={field.name} />
    </>
  )
}
